import React from 'react'
import Grid from '@mui/material/Grid2'
import Image from '@/components/image/Image'
import Link from '@mui/material/Link'

// <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d555.3025377054552!2d14.858635269712297!3d56.170759998327604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTbCsDEwJzE0LjkiTiAxNMKwNTEnMzMuMyJF!5e0!3m2!1sen!2sse!4v1753256743850!5m2!1sen!2sse" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

const locations = {
  scoutstugan:
    // eslint-disable-next-line max-len
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1205.412642690732!2d14.887628584852585!3d56.15611855534654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46568453244f78b1%3A0x36929f8ed1842bab!2sKarlshamns%20Sj%C3%B6scoutk%C3%A5r!5e0!3m2!1sen!2sse!4v1741340880472!5m2!1sen!2sse',
  snackan:
    // eslint-disable-next-line max-len
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d555.3709860064677!2d14.870852128557816!3d56.16602674503196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465685041150e91d%3A0x8196926978f569c0!2zU27DpGNrYW4!5e0!3m2!1sen!2sse!4v1745509231274!5m2!1sen!2sse',
  kastellet:
    // eslint-disable-next-line max-len
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1144.5271797643986!2d14.861884769523561!3d56.16691107537107!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46568519dcc4ca21%3A0x6b4d8e43fcbdef8e!2sBlekingetrafiken%20-%20Sk%C3%A4rg%C3%A5rdstrafik!5e0!3m2!1sen!2sse!4v1746167913775!5m2!1sen!2sse',
  mian:
    // eslint-disable-next-line max-len
    'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d555.3025377054552!2d14.858635269712297!3d56.170759998327604!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTbCsDEwJzE0LjkiTiAxNMKwNTEnMzMuMyJF!5e0!3m2!1sen!2sse!4v1753256743850!5m2!1sen!2sse',
}

const CurrentEvent: React.FC = () => {
  return (
    <Grid size={{ xs: 11, md: 4 }}>
      <h2>Kommande Event</h2>
      <h2>Kulturnatten</h2>
      <h3>
        Kom och lyssna på oss!
        <br />
        4 oktober
        <br />
      </h3>
      <p>
        Årliga spelningen på kulturnatten vid Mieån ihop med scouterna.
        Klockslag kommer.
      </p>
      <Image src="/images/events/kulturnatten-2024.jpg" alt="Poster" />
      <h3>Här spelar vi:</h3>
      <iframe
        title="Google maps karta"
        src={locations.mian}
        width="100%"
        height={450}
        style={{
          border: 0,
          borderRadius: 10,
        }}
      />
    </Grid>
  )
}

export default CurrentEvent
